module.exports = __webpack_public_path__ + "static/media/wrinkles.78441a8e.svg";